import React, { useEffect, useState } from 'react'
import { useAuthFromContext } from '../AuthContext'
import { db } from '../FirebaseConfig'
import { ref, get } from 'firebase/database'
import './MatchHistory.css'

function formatDate(epochMs) {
    if (!epochMs) return '—'
    return new Date(epochMs).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export default function MatchHistory({ onBack }) {
    const { user } = useAuthFromContext()
    const [matches, setMatches] = useState(null)

    useEffect(() => {
        if (!user) return
        get(ref(db, `matchHistory/${user.uid}`)).then(snap => {
            if (!snap.exists()) { setMatches([]); return }
            const list = Object.values(snap.val())
            list.sort((a, b) => (b.endedAt || 0) - (a.endedAt || 0))
            setMatches(list)
        })
    }, [user])

    return (
        <div className="mh-screen">
            <button className="mh-back" onClick={onBack}>← Back</button>
            <h1 className="mh-title">Match History</h1>

            {matches === null && (
                <p className="mh-empty">Loading...</p>
            )}

            {matches !== null && matches.length === 0 && (
                <p className="mh-empty">No matches yet.</p>
            )}

            {matches !== null && matches.length > 0 && (
                <ul className="mh-list">
                    {matches.map(m => (
                        <li key={m.matchId} className={`mh-row mh-row--${m.outcome}`}>
                            <span className={`mh-outcome mh-outcome--${m.outcome}`}>
                                {m.outcome.toUpperCase()}
                            </span>
                            <span className="mh-opponent">{m.opponentName}</span>
                            <span className="mh-date">{formatDate(m.endedAt)}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
